import styled from '@emotion/styled';

export const StepBox = styled.div`
  border-bottom: 1px solid black;
  color: black;
  font-size: 14px;
  font-weight: bold;
  line-height: 12px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  width: 100%;
`;

const commonModalDropdownCSS = `
  background-color: white;
  border: 1px solid #e5e5e5;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  box-shadow: 2px 2px 2px #e5e5e5;
  max-height: 300px;
  overflow: scroll;
  & > li {
    height: 100%;
    width: 100%;
    &:hover {
      background-color: #cccccc;
    }
    & > div {
      height: 100%;
      padding: 8px 16px;
      width: 100%;
    }
  }
`;

export const SpecializedDropdownInModal = styled.ul`
  position: fixed;
  z-index: 999;
  width: ${({ width }) => width || '100%'};
  ${commonModalDropdownCSS}
`;

export const SpecializedDropdown = styled.ul`
  position: absolute;
  top: 64px;
  width: 100%;
  z-index: 1;
  ${commonModalDropdownCSS}
`;
